export const colors =  {
  yellow: '#FFF176',
  brown:  '#592B0D',
  red:    '#D32F2F',
  white:  '#FFFFFF',
  black:  '#000000'
}
